import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onSetMarkerIndexPressed, onSetScaleHotSpotEnabled } from '../../../store/actions';
import { INITIAL_ZOOM_LEVEL, SELECTION_MARKER_HEIGHT, SELECTION_MARKER_WIDTH } from '../../../utils';
import LineBox from '../LineBox/LineBox';
import Plane from '../Plane/Plane';
const Marker = ({ id, position: [x, y], onPointerDown, onPointerUp, onPointerOver, onPointerOut }) => {
    const dispatch = useDispatch();
    const zoomAdjFactor = useSelector((state) => (INITIAL_ZOOM_LEVEL / state.userReducer.zoomLevel) * 0.25);
    const backgroundHotspotIsEnabled = useSelector((state) => state.userReducer.backgroundHotspotIsEnabled);
    const isScreenRelativeMode = useSelector((state) => state.userReducer.isScreenRelativeMode);
    const scale = (isScreenRelativeMode ? [0.018, 0.018, 0.01] : [SELECTION_MARKER_HEIGHT * zoomAdjFactor, SELECTION_MARKER_WIDTH * zoomAdjFactor, 0.025 * zoomAdjFactor]);
    const pointerDownHandler = (e) => {
        onPointerDown?.(e);
        e.stopPropagation();
        dispatch(onSetMarkerIndexPressed(id));
        dispatch(onSetScaleHotSpotEnabled(true));
    };
    const pointerUpHandler = (e) => {
        onPointerUp?.(e);
        e.stopPropagation();
        dispatch(onSetMarkerIndexPressed(null));
    };
    return (_jsxs(_Fragment, { children: [_jsx(LineBox, { enabled: !backgroundHotspotIsEnabled, color: [0, 176, 255, 1], rotation: [0, 0, 0], position: [x, y, 0.005], scale: [scale[0], scale[1]], 
                // name={"MarkerLineBox"}
                renderOrder: 999995 }), _jsx(Plane, { scale: scale, name: 'MarkerPlane', id: `ScaleMarker${id}`, isMarkerPlane: true, enabled: true, position: [x, y, 0], 
                // depthWrite={false}
                rotation: [0, 0, 0], color: [255, 255, 255, 1], pointerDownHandler: (e) => {
                    pointerDownHandler(e);
                }, pointerUpHandler: (e) => {
                    pointerUpHandler(e);
                }, pointerOverHandler: onPointerOver || undefined, pointerOutHandler: onPointerOut || undefined, renderOrder: 999999 })] }));
};
export default Marker;
